import { useMemo } from 'react';

const useIsDev = () => {
  const dev = process.env.NODE_ENV === 'development';

  return useMemo(() => dev, [dev]);
};

export default useIsDev;
